<lib-question-display [question]="question.value" />
<ion-textarea
  [formControl]="textareaCtrl"
  placeholder="Voer hier je antwoord in."
  aria-label="Voer hier je antwoord in."
  [autoGrow]="true"
  fill="outline"
  mode="md"
  class="self-exam-question-input"
/>
